import * as history from 'history'
import createBrowserHistory from 'history/createBrowserHistory'

type UnregisterListenCallback = history.UnregisterCallback
type Location = history.Location
type LocationListener = (location: Location) => void

interface IHashParams {
  [key: string]: string
}

class LocationHistory {
  private prevHash = '#/'

  constructor(private browserHistory = createBrowserHistory()) {
    browserHistory.listen((location) => {
      const hashChanged = this.prevHash !== location.hash
      if (this.prevHash || hashChanged) {
        window.scrollTo(0, 0)
      }

      this.prevHash = location.hash
    })
  }

  listen(listener: LocationListener, immediate = true): UnregisterListenCallback {
    if (immediate) {
      listener(this.browserHistory.location)
    }

    return this.browserHistory.listen(listener)
  }

  getHistoryObject() {
    return this.browserHistory
  }

  replace(hash: string) {
    const { pathname } = this.browserHistory.location

    if (hash.indexOf('#') !== 0) {
      hash = '#' + hash
    }

    return this.browserHistory.replace(pathname + hash)
  }

  relocate(path: string, hashparams?: IHashParams) {
    let hashParamsStr = ''

    if (path.indexOf('#') !== 0) {
      path = '#' + path
    }

    if (hashparams) {
      hashParamsStr = '?'

      Object.keys(hashparams).forEach((key, i) => {
        const value = encodeURIComponent(hashparams[key])

        if (i > 0) {
          hashParamsStr += '&'
        }

        hashParamsStr += `${key}=${value}`
      })
    }

    location.hash = path + hashParamsStr
  }

  getHashParams(): IHashParams {
    const { hash } = location
    const qIndex = hash.indexOf('?')
    const hashParams = {}

    if (qIndex > 0) {
      const hashParamStr = hash.substring(qIndex + 1)
      const hashParamParts = hashParamStr.split('&')

      hashParamParts.forEach((part) => {
        const keyValueParts = part.split('=')
        const key = keyValueParts[0]
        const value = decodeURIComponent(keyValueParts[1])

        hashParams[key] = value
      })
    }

    return hashParams
  }
}

const AppHistory = new LocationHistory()

export {
  IHashParams,
  AppHistory,
  LocationHistory,
  UnregisterListenCallback,
  Location,
  LocationListener
}



// WEBPACK FOOTER //
// ./src/app/containers/AppHistory.ts